module.exports = __webpack_public_path__ + "static/img/3.2316aa7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/zh/3.png
// module id = p3Dj
// module chunks = 0